(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["alpha-home-editorial-2026"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-ahe-tabs]').forEach((tabs) => {
    const buttons = tabs.querySelectorAll('[data-ahe-tab]');
    const panels = tabs.querySelectorAll('[data-ahe-panel]');
    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const group = button.dataset.aheTab;
        buttons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
        panels.forEach((panel) => { panel.hidden = panel.dataset.ahePanel !== group; });
      });
    });
  });
  document.querySelectorAll('.ahe__nav-drop').forEach((menu) => {
    menu.addEventListener('toggle', () => {
      if (!menu.open) return;
      document.querySelectorAll('.ahe__nav-drop').forEach((other) => {
        if (other !== menu) other.removeAttribute('open');
      });
    });
  });
  document.addEventListener('click', (event) => {
    if (event.target.closest('.ahe__nav-drop')) return;
    document.querySelectorAll('.ahe__nav-drop[open]').forEach((menu) => menu.removeAttribute('open'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
